import React from "react";

const SortableHeader = ({ label, column, searchParams, handleSort }) => {
  const isActive = searchParams.sortBy === column;
  const isAsc = searchParams.sortOrder === "ASC";
  const isDesc = searchParams.sortOrder === "DESC";

  return (
    <th>
      <div className="sortable-header">
        <span>{label}</span>
        <div className="sortable-header__arrows">
          <button
            onClick={() => handleSort(column, "ASC")}
            className={`sortable-header__button ${
              isActive && isAsc ? "sortable-header__button--active" : ""
            }`}
            aria-label={`Sort ${label} ascending`}
          >
            ▲
          </button>
          <button
            onClick={() => handleSort(column, "DESC")}
            className={`sortable-header__button ${
              isActive && isDesc ? "sortable-header__button--active" : ""
            }`}
            aria-label={`Sort ${label} descending`}
          >
            ▼
          </button>
        </div>
      </div>
    </th>
  );
};

export default SortableHeader;
